export enum TopDonationsSourceType {
  All,
  Campaign,
  Event,
  SocialMedia,
  Donor
}
